import React from 'react';
import { connect } from 'react-redux';
import TopHeader from '../template/TopHeader';
import CatalogueTopNav from '../new-service/CatalogueTopNav';
import TaxesContent from './TaxesContent';

// Catalogue › Taxes: thin page shell; the content lives in TaxesContent
// so it can render (and be visually tested) without the app chrome.
function TaxesPage(props) {
  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className="catalogue-page-wrapper">
          <CatalogueTopNav {...props} />
          <div className="catalogue-content-container">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <TaxesContent />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(TaxesPage);
